import { tns } from "./../../../../../node_modules/tiny-slider/src/tiny-slider";

export default class ImagesSliderModule {
    gallery = null;
    imagesSlider = null;
    container = null;

    constructor(gallery, options = null) {
        this.gallery = gallery;
        this.container = document.querySelector('.slider__container');
        this.appendSliderImages();
        this.initSlider(options);
        this.bindImageClick();
    }

    appendSliderImages = () => {
        this.gallery.items.forEach((image, index) => {
            const img = document.createElement('img');
            img.src = image;
            img.dataset.id = index;
            img.alt = "";

            this.container.appendChild(img);
        });
    }

    initSlider = (options) => {
        this.imagesSlider = tns({
            preventScrollOnTouch: options?.preventScrollOnTouch ?? 'force',
            container: options?.container ?? this.container,
            items: options?.items ?? 4,
            gutter: options?.gutter ?? 10,
            navPosition: options?.navPosition ?? 'bottom',
            mouseDrag: options?.mouseDrag ?? true,
            center: options?.center ?? false,
            controls: options?.controls ?? true,
            swipeAngle: options?.swipeAngle ?? false,
            arrowKeys: options?.arrowKeys ?? false
        });
    }

    bindImageClick = () => {
        const imagesInSlider = this.container.querySelectorAll('.tns-item');

        imagesInSlider.forEach(image => {
            image.addEventListener('click', () => {
                const imgId = image.dataset.id;
                this.gallery.open(imgId);
            });
        });
    }
}